export const PAGE_TITLE_ADDITION = ' | RELOAVED'
export const PLATFORM_TITLE = 'RELOAVED'
